export default __webpack_public_path__ + "static/media/default-avatar2.41bd31cb.svg";